<template>
  <div
    @click="onClick"
  >
    <ui-badge
      :text="COUNT"
      max-width="50"
    />
    <f-sprite-icon
      :icon-link="$options.icons.IconHeart.id"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import IconHeart from '@icons/heart.svg';

export default {
  name: 'control-favorites',

  icons: {
    IconHeart,
  },

  computed: {
    ...mapGetters({
      COUNT: 'favorites/favoritesShortCount',
    }),
  },

  mounted () {
    this.LOAD_FAVORITES_SHORT();
  },

  methods: {
    ...mapActions({
      LOAD_FAVORITES_SHORT: 'favorites/loadFavoritesShort',
    }),
    onClick() {
      this.$f.login().then(() => {
        this.$router.push({ path: '/account/favorites' });
      }).catch(() => {});
    }
  },
}
</script>
